import { Plus, ChartPieSlice } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { VistorModalTypes } from '../modals/utils'
import VisitorsAnalytics from '../analytics/VisitorsAnalytics'

import ToolbarMenu from './ToolbarMenu'

const VisitorsToolbar = ({
  analyticsOpen,
  setAnalyticsOpen,
  setNewVisitorModalOpen,
  designSwitch,
}) => {
  const { t } = useTranslation(['visitors'])
  const routes = [
    { name: t('visitors:toolbar.guests'), path: '/dashboard/building-dashboard/visitors/guests' },
    { name: t('visitors:toolbar.vendors'), path: '/dashboard/building-dashboard/visitors/vendors' },
    { name: t('visitors:toolbar.history'), path: '/dashboard/building-dashboard/visitors/history' },
  ]

  const toggleAnalytics = () => {
    setAnalyticsOpen((prev) => !prev)
  }

  return (
    <div className="visitors-toolbar">
      <div className="visitors-top-navbar">
        <div className="header-section">
          <div className="header">{t('visitors:toolbar.title')}</div>
          <button className="button button-transparent" onClick={toggleAnalytics}>
            <ChartPieSlice size={20} />
            {analyticsOpen
              ? t('visitors:toolbar.hideAnalytics')
              : t('visitors:toolbar.showAnalytics')}
          </button>
        </div>
        <div className="header-buttons">
          {designSwitch}
          <button
            className="button button-primary"
            onClick={() => setNewVisitorModalOpen(VistorModalTypes.VisitorTypeModal)}
          >
            <Plus weight="bold" />
            {t('visitors:toolbar.addNew')}
          </button>
        </div>
      </div>
      {analyticsOpen && <VisitorsAnalytics />}
      <ToolbarMenu routes={routes} />
    </div>
  )
}
VisitorsToolbar.propTypes = {
  analyticsOpen: PropTypes.bool.isRequired,
  setAnalyticsOpen: PropTypes.func.isRequired,
  setNewVisitorModalOpen: PropTypes.func.isRequired,
  designSwitch: PropTypes.node,
}

export default VisitorsToolbar
